import { APIENDPOINTS } from "../../constants/apiEndPoint";
import { baseApi } from "./baseQuery";

const authPageApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.LOGIN,
                method: "POST",
                body: values
            }),
        }),

        forgotPassword: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.FORGOT_PASSWORD,
                method: "POST",
                body: values
            }),
        }),

        resetPassword: build.mutation({
            query: (values) => ({
                url: APIENDPOINTS.RESET_PASSWORD,
                method: "POST",
                body: values
            }),
        }),

        // refreshToken: build.mutation({
        //     query: (values) => ({
        //         url: ApiEndPoints.refreshToken,
        //         method: "POST",
        //         body: values
        //     }),
        // }),

        // changePassword: build.mutation({
        //     query: (values) => ({
        //         url: ApiEndPoints.changePassword,
        //         method: "POST",
        //         body: values
        //     }),
        // }),

        // profileGet: build.query({
        //     query: (values) => ({
        //         url: ApiEndPoints.userList + `/${values}`,
        //     }),
        //     providesTags: ['profile', 'userManage']
        // }),

        // profileUpdateHeader: build.mutation({
        //     query: (values) => ({
        //         url: ApiEndPoints.getProfileHeader + values.id,
        //         method: "PUT",
        //         body: values.body
        //     }),
        //     invalidatesTags: ['profile']
        // }),

        // logOut: build.query({
        //     query: () => ({
        //         url: ApiEndPoints.logout,
        //     }),
        // }),

    }),
    // @ts-ignore
    overrideExisting: module.hot?.status() === "apply",
});

export const {
    useLoginMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    // useRefreshTokenMutation,
    // useChangePasswordMutation,
    // useProfileGetQuery,
    // useProfileUpdateHeaderMutation,
    // useLogOutQuery
} = authPageApi;